// Same variable names as the v1 frontend, so one .env serves both.
export const env = {
  apiBaseUrl: import.meta.env.REACT_APP_API_BASE_URL as string,
  wsBaseUrl: import.meta.env.REACT_APP_WS_BASE_URL as string,
  customersApiBaseUrl: import.meta.env.REACT_APP_CUSTOMERS_API_BASE_URL as string,
  cityViewUrl: 'https://city.metafor.ai',
  firebase: {
    apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: import.meta.env.REACT_APP_AUTH_DOMAIN as string,
    projectId: import.meta.env.REACT_APP_PROJECT_ID as string,
    storageBucket: import.meta.env.REACT_APP_STORAGE_BUCKET as string,
    messagingSenderId: import.meta.env.REACT_APP_MESSAGING_SENDER_ID as string,
    appId: import.meta.env.REACT_APP_APP_ID as string,
  },
}

/** HubSpot app install link (OAuth); the API's callback stores the connection. */
export const hubspotInstallUrl = import.meta.env.REACT_APP_HUBSPOT_INSTALL_URL as string | undefined
